import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-indigo-700 px-6 py-8 sm:px-10 sm:py-12">
            <h1 className="text-3xl font-bold text-white mb-2">Terms of Service</h1>
            <p className="text-blue-100">Effective Date: September 14, 2025</p>
          </div>
          
          <div className="px-6 py-8 sm:px-10 sm:py-12">
            <div className="prose prose-blue max-w-none">
              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptance of Terms</h2>
                <p className="text-gray-600">
                  By accessing or using the NeuralVision Traffic Movement Count Analysis Platform (the "Service"), you agree to be bound by these Terms of Service ("Terms") and our Privacy Policy. If you disagree with any part of these terms, you may not access the Service.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Description of Service</h2>
                <p className="text-gray-600">
                  NeuralVision provides a cloud-based platform for traffic movement count analysis using artificial intelligence and computer vision technologies. The Service processes traffic video footage to generate Traffic Movement Count (TMC) reports in various formats.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Account Registration</h2>
                <p className="text-gray-600 mb-3">To use certain features of the Service, you must register for an account. You agree to:</p>
                <ul className="list-disc pl-5 space-y-2 text-gray-600">
                  <li>Provide accurate, current, and complete information</li>
                  <li>Maintain and promptly update your account information</li>
                  <li>Maintain the security of your password</li>
                  <li>Accept all risks of unauthorized access to your account</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. User Content and Responsibilities</h2>
                <p className="text-gray-600 mb-3">You are responsible for all content you upload to the Service:</p>
                <ul className="list-disc pl-5 space-y-2 text-gray-600">
                  <li>Ensure you have proper authorization to upload video content</li>
                  <li>Comply with all applicable laws and regulations</li>
                  <li>Do not upload content that infringes on others' rights</li>
                  <li>Do not upload malicious, illegal, or inappropriate content</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Intellectual Property</h2>
                <p className="text-gray-600 mb-3">
                  The Service and its original content, features, and functionality are owned by NeuralVision and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
                </p>
                <p className="text-gray-600">
                  You retain ownership of your content, but you grant us a license to use, host, store, reproduce, modify, create derivative works, communicate, publish, publicly display, and distribute your content solely for the purpose of providing the Service.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Subscription and Payments</h2>
                <p className="text-gray-600 mb-3">Our Service operates on subscription plans with the following terms:</p>
                <ul className="list-disc pl-5 space-y-2 text-gray-600">
                  <li>All fees are exclusive of taxes, which we will charge as required</li>
                  <li>Subscriptions automatically renew unless canceled</li>
                  <li>We may change prices with 30 days' notice</li>
                  <li>No refunds for partial months, but pro-rated refunds for annual plans canceled early</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Termination</h2>
                <p className="text-gray-600">
                  We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Disclaimer of Warranties</h2>
                <p className="text-gray-600">
                  The Service is provided on an "AS IS" and "AS AVAILABLE" basis. The Service is provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties of merchantability, fitness for a particular purpose, non-infringement or course of performance.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Limitation of Liability</h2>
                <p className="text-gray-600">
                  In no event shall NeuralVision, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Governing Law</h2>
                <p className="text-gray-600">
                  These Terms shall be governed and construed in accordance with the laws of British Columbia, Canada, without regard to its conflict of law provisions.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Changes to Terms</h2>
                <p className="text-gray-600">
                  We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide at least 30 days' notice prior to any material changes becoming effective.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Contact Information</h2>
                <div className="bg-blue-50 rounded-lg p-4">
                  <p className="text-gray-700"><strong>Email:</strong> <a href="mailto:info@neuralvision.ca" className="text-blue-600 hover:text-blue-800">info@neuralvision.ca</a></p>
                </div>
              </section>
            </div>

            <div className="mt-10 pt-6 border-t border-gray-200">
              <Link 
                to="/dashboard" 
                className="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Back to Dashboard
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;